import { createSelector } from '@ngrx/store';

import * as fromOsm from '../../features/osm/shared/state/selectors/osm.selectors';
import * as fromSchaden from '../../features/osm/shared/state/selectors/schaden.selectors';
import * as fromCore from '../selectors/core.selectors';
import { selectUrl } from '../selectors/router.selectors';

export const selectLoadContactParams = createSelector(
    fromSchaden.selectIdentifikation,
    fromCore.selectIsProtekta,
    fromCore.selectLanguage,
    (identifikation, protekta, language) => ({ identifikation, protekta, language }),
);

export const selectLoginParams = createSelector(
    fromCore.selectPortalToken,
    fromOsm.selectCurrentStep,
    selectUrl,
    (portal, step) => ({ portal, step }),
);
